__turbopack_context__.v({
  "avatar": "DemoDayCard-module-scss-module__TGuqeq__avatar",
  "avatarImg": "DemoDayCard-module-scss-module__TGuqeq__avatarImg",
  "badge": "DemoDayCard-module-scss-module__TGuqeq__badge",
  "badgeActive": "DemoDayCard-module-scss-module__TGuqeq__badgeActive",
  "badgeArchived": "DemoDayCard-module-scss-module__TGuqeq__badgeArchived",
  "badgeCompleted": "DemoDayCard-module-scss-module__TGuqeq__badgeCompleted",
  "badgeDefault": "DemoDayCard-module-scss-module__TGuqeq__badgeDefault",
  "badgeRegistrationOpen": "DemoDayCard-module-scss-module__TGuqeq__badgeRegistrationOpen",
  "badgeText": "DemoDayCard-module-scss-module__TGuqeq__badgeText",
  "badgeUpcoming": "DemoDayCard-module-scss-module__TGuqeq__badgeUpcoming",
  "card": "DemoDayCard-module-scss-module__TGuqeq__card",
  "cardContent": "DemoDayCard-module-scss-module__TGuqeq__cardContent",
  "completed": "DemoDayCard-module-scss-module__TGuqeq__completed",
  "date": "DemoDayCard-module-scss-module__TGuqeq__date",
  "dateText": "DemoDayCard-module-scss-module__TGuqeq__dateText",
  "description": "DemoDayCard-module-scss-module__TGuqeq__description",
  "highlighted": "DemoDayCard-module-scss-module__TGuqeq__highlighted",
  "moreButton": "DemoDayCard-module-scss-module__TGuqeq__moreButton",
  "nonClickable": "DemoDayCard-module-scss-module__TGuqeq__nonClickable",
  "overline": "DemoDayCard-module-scss-module__TGuqeq__overline",
  "textBlock": "DemoDayCard-module-scss-module__TGuqeq__textBlock",
  "title": "DemoDayCard-module-scss-module__TGuqeq__title",
});
